import * as types from 'Redux/types/relatedPhotos';
import { requestOptions } from 'Helpers/Graphql';
import yup from 'yup';

import photoBasicsFragment from 'Gql/fragments/photo.basics';
import photoCaptionFragment from 'Gql/fragments/photo.caption';
import photoResoltionsGalleryFragment from 'Gql/fragments/photo.resolutions.gallery';

export const fetchByTags = (params = {}, req = null) => dispatch => {
    params = {
        ...params,
        tags: params.tags,
        photoId: params.photoId,
        query: params.tags.join(' '),
        page: params.page || 1,
        perPage: params.perPage || 12
    };

    return requestOptions({
        req: req,
        type: types.BY_TAGS,
        onRetry: fetchByTags,
        name: 'marketRelatedPhotos',
        params: params,
        requestParams: {
            query: params.query,
            page: params.page,
            perPage: params.perPage
        },
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                photos: yup.object().shape({
                    edges: yup.array().of(
                        yup.object().shape({
                            node: yup.object().shape({
                                id: yup.string().required(),
                                slug: yup.string().nullable(),
                                width: yup.number().required(),
                                height: yup.number().required(),
                                caption: yup.string().nullable(),
                                suggestedCaption: yup.string().nullable(),
                                curatedCaption: yup.string().nullable(),
                                resolutions: yup.object().shape({
                                    w640: yup.string().nullable()
                                }).required()
                            }).nullable()
                        })
                    ).ensure(),
                    perPage: yup.number().required(),
                    totalCount: yup.number().required()
                }).required()
            }).required()
        }),
        query: `
            query marketRelatedPhotos (
                $query: String!
                $page: Int
                $perPage: Int
            ){
                photos: marketPhotos (
                    query: $query
                    page: $page
                    perPage: $perPage
                ) {
                    edges {
                        node {
                            ...photoBasics
                            ...photoCaption
                            ...photoResolutionsGallery
                        }
                    }
                    totalCount
                    perPage
                }
            }
            ${photoBasicsFragment}
            ${photoCaptionFragment}
            ${photoResoltionsGalleryFragment}
        `
    });
};



// WEBPACK FOOTER //
// ./src/redux/actions/relatedPhotos.js